import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  /**
   * モニターKPI一覧を取得
   * @returns {Promise} - { monitorKpis: { data: MonitorKpi[] } }
   */
  getMonitorKpis() {
    return axiosIns.get('/admin/monitor_kpis')
  },

  /**
   * モニターKPIを作成
   * @param {Object} params
   * @param {string} params.title - KPIのタイトル
   * @param {number} params.vendibleTagId - 商品タグID
   * @param {number} [params.position] - 表示順
   * @returns {Promise} - { monitorKpi: { data: MonitorKpi } }
   */
  createMonitorKpi({ title, vendibleTagId, position }) {
    const params = snakecaseKeys({
      monitorKpi: { title, vendibleTagId, position },
    })

    return axiosIns.post('/admin/monitor_kpis', params)
  },

  /**
   * モニターKPIを更新
   * @param {Object} params
   * @param {number} params.id - モニターKPI ID
   * @param {string} [params.title] - KPIのタイトル
   * @param {number} [params.vendibleTagId] - 商品タグID
   * @param {number} [params.position] - 表示順
   * @returns {Promise} - { monitorKpi: { data: MonitorKpi } }
   */
  updateMonitorKpi({
    id, title, vendibleTagId, position,
  }) {
    const params = snakecaseKeys({
      monitorKpi: { title, vendibleTagId, position },
    })

    return axiosIns.put(`/admin/monitor_kpis/${id}`, params)
  },

  /**
   * モニターKPIを削除
   * @param {number} id - モニターKPI ID
   * @returns {Promise}
   */
  deleteMonitorKpi(id) {
    return axiosIns.delete(`/admin/monitor_kpis/${id}`)
  },
}
